export const AUTH_ROUTE = "/auth" as const;
export const ONBOARDING_ROUTE = "/onboarding/company-setup" as const;
export const SUBSCRIPTION_SETUP_ROUTE = "/$companySlug/subscribe" as const;
export const SUBSCRIPTION_OVERDUE_ROUTE =
  "/$companySlug/subscribe/overdue" as const;
export const SHARE_ROUTE = "/share/" as const;
